__turbopack_context__.v({
  "btnIconClose": "styles-module-scss-module__6O-KHa__btnIconClose",
  "closeIconWrapper": "styles-module-scss-module__6O-KHa__closeIconWrapper",
  "content": "styles-module-scss-module__6O-KHa__content",
  "description": "styles-module-scss-module__6O-KHa__description",
  "marginTop10": "styles-module-scss-module__6O-KHa__marginTop10",
  "modal": "styles-module-scss-module__6O-KHa__modal",
  "subTitle": "styles-module-scss-module__6O-KHa__subTitle",
  "title": "styles-module-scss-module__6O-KHa__title",
  "wrapper": "styles-module-scss-module__6O-KHa__wrapper",
});
